import script from "./RightToWorkFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./RightToWorkFormView.vue?vue&type=script&setup=true&lang=js"

import "./RightToWorkFormView.vue?vue&type=style&index=0&id=6b38063a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b38063a"]])

export default __exports__